import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import ReactSVG from "react-svg";
import Media from "react-responsive";
import { xMediumScreen } from "@styles/constants";
import { StatusData, StatusDataFooter } from "@components/molecules";
import ModalViewRoute from "@components/molecules/ModalViewRoute";
import { commonMessages, statusMessages } from "@temp/intl";
import * as S from "./styles";

var arrivedImg = require("../../../../images/arrived.gif");

var goBackImg = require("../../../../images/arrowBack.svg");

/**
 * arrived status structure
 */
var StatusArrived = function StatusArrived(_ref) {
  var _data$lastFulfillment, _data$lastFulfillment2, _data$lastFulfillment3, _data$lastFulfillment4, _data$lastFulfillment5, _data$lastFulfillment6;

  var data = _ref.data,
      goBack = _ref.goBack;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var handleViewRoute = function handleViewRoute() {
    setShowModal(true);
  };

  var handleCloseModal = function handleCloseModal() {
    setShowModal(false);
  };

  return React.createElement(S.Wrapper, null, React.createElement(S.Tile, null, React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(S.Title, null, React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(S.BackTitle, {
    onClick: goBack
  }, React.createElement(ReactSVG, {
    path: goBackImg
  }), React.createElement(S.BackTitleParragraph, null, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusArrived.StatusArrived.3471378517",
    defaultMessage: "back"
  })))), React.createElement(FormattedMessage, statusMessages.stepNameArrived)))), React.createElement(S.Content, null, React.createElement(Media, {
    maxWidth: xMediumScreen
  }, React.createElement(S.Title, null, React.createElement(FormattedMessage, statusMessages.stepNameArrived))), React.createElement(S.ContentContainer, null, React.createElement(S.Gif, null, React.createElement("img", {
    alt: "cargando",
    src: arrivedImg
  })), React.createElement(S.Parragraph, {
    "data-test": "checkoutPageSubtitle"
  }, React.createElement(FormattedMessage, statusMessages.stepNameArrivedWaiting)), (data === null || data === void 0 ? void 0 : (_data$lastFulfillment = data.lastFulfillment) === null || _data$lastFulfillment === void 0 ? void 0 : _data$lastFulfillment.deliveryValidationCode) && React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(S.DeliveryCode, null, React.createElement(S.DeliveryCodeTitle, null, React.createElement(FormattedMessage, commonMessages.deliveryCode)), React.createElement(S.DeliveryCodeNumber, null, data === null || data === void 0 ? void 0 : (_data$lastFulfillment2 = data.lastFulfillment) === null || _data$lastFulfillment2 === void 0 ? void 0 : _data$lastFulfillment2.deliveryValidationCode), React.createElement(S.ParragraphTwo, {
    style: {
      marginTop: "0.8rem",
      fontSize: "0.75rem",
      color: "#666",
      textAlign: "center",
      lineHeight: "1.3"
    }
  }, React.createElement(FormattedMessage, commonMessages.verifyYourOrder)))))), React.createElement(S.Aside, null, (data === null || data === void 0 ? void 0 : (_data$lastFulfillment3 = data.lastFulfillment) === null || _data$lastFulfillment3 === void 0 ? void 0 : _data$lastFulfillment3.deliveryValidationCode) && React.createElement(Media, {
    maxWidth: xMediumScreen
  }, React.createElement(S.DeliveryCodeMobile, null, React.createElement(S.DeliveryCodeTitle, null, React.createElement(FormattedMessage, commonMessages.deliveryCode)), React.createElement(S.DeliveryCodeNumber, null, data === null || data === void 0 ? void 0 : (_data$lastFulfillment4 = data.lastFulfillment) === null || _data$lastFulfillment4 === void 0 ? void 0 : _data$lastFulfillment4.deliveryValidationCode), React.createElement(S.ParragraphTwo, {
    style: {
      marginTop: "0.8rem",
      fontSize: "0.75rem",
      color: "#666",
      textAlign: "center",
      lineHeight: "1.3"
    }
  }, React.createElement(FormattedMessage, commonMessages.verifyYourOrder)))), React.createElement(StatusData, {
    deliveryPhone: true,
    data: data,
    deliveryData: true,
    showViewRouteButton: !!(data === null || data === void 0 ? void 0 : (_data$lastFulfillment5 = data.lastFulfillment) === null || _data$lastFulfillment5 === void 0 ? void 0 : _data$lastFulfillment5.externalTraking),
    onViewRoute: handleViewRoute
  })), React.createElement(S.Footer, null, React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(StatusDataFooter, {
    data: data
  }))), showModal && React.createElement(ModalViewRoute, {
    externalTraking: data === null || data === void 0 ? void 0 : (_data$lastFulfillment6 = data.lastFulfillment) === null || _data$lastFulfillment6 === void 0 ? void 0 : _data$lastFulfillment6.externalTraking,
    onClose: handleCloseModal
  }));
};

export { StatusArrived };